import React from "react";

const DisplaySkill = ({ skill, index }) => {
  return (
    <>
      <img
        data-tooltip-target={`${skill.name}-tooltip-hover`}
        data-tooltip-trigger="hover"
        className="w-[50px] h-[50px] mr-[60px] hover:scale-110 duration-300 mt-[20px]"
        src={skill.url}
        alt={skill.name}
      />
      <div
        id={`${skill.name}-tooltip-hover`}
        role="tooltip"
        className="absolute z-90 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 transition delay-100 ease-in-out duration-1000"
      >
        {skill.name}
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>
    </>
  );
};

export default DisplaySkill;
